import { persistentAtom } from '@nanostores/persistent'
import { atom } from 'nanostores'

export const checkoutData = persistentAtom(
    'ma_checkout',
    {},
    {
        encode(checkoutObj) {
            return JSON.stringify(checkoutObj)
        },
        decode(checkoutObj) {
            return JSON.parse(checkoutObj)
        },
    }
)
